<template>
  <el-container>
    <el-main v-if="reviewForm.visible">
      <el-page-header
        @back="reviewForm.visible = false"
        class="question-page-header"
      >
        <template v-slot:content>
          <div>详情页面</div>
        </template>
      </el-page-header>
      <answer-layer
        v-if="reviewForm.type === 'question'"
        class="mt-5"
        v-bind="reviewForm.params"
        @change-type="handleStart('scene', reviewForm.row)"
        @pivot="handleAnswerPivot"
        @save="updateProgress"
      />
      <scene-layer
        v-else
        class="mt-5"
        v-bind="reviewForm.params"
        @change-type="reviewForm.visible = false"
        @pivot="handleScenePivot"
        @save="updateProgress"
      />
    </el-main>
    <el-main v-else-if="reportForm.visible">
      <el-page-header
        @back="reportForm.visible = false"
        class="question-page-header"
      >
        <template v-slot:content>
          <div>编辑表单</div>
        </template>
      </el-page-header>
      <!-- <report-view :info="reportForm.params" :evaluate="evaluate" :evaluate-scenes="evaluateScenes" :question-obj="questionAnswerObj" :scene-obj="sceneAnswerObj" :avg-data="avgData" :expert="experts" /> -->
      <report-view
        :info="reportForm.params"
        :evaluate="evaluate"
        :evaluate-scenes="evaluateScenes"
        :question-obj="questionAnswerObj"
        :scene-obj="sceneAnswerObj"
        :expert="experts"
        @refresh="loadList()"
      />
    </el-main>
    <!-- 生成佐证 -->

    <el-main v-else-if="evidenceForm.visible">
      <generat-evidence
        :userId="evidenceForm.row.userId"
        @close="evidenceForm.visible = false"
      ></generat-evidence>
    </el-main>
    <el-main v-else>
      <el-form
        inline
        size="mini"
        @keydown.enter.native="(event) => event.preventDefault()"
      >
        <el-form-item style="width: 15%">
          <el-input
            size="mini"
            v-model="queryParams.enterpriseName"
            clearable
            placeholder="请输入公司名称"
          />
        </el-form-item>
        <el-form-item style="width: 10%">
          <el-select
            v-model="queryParams.declarationStatus"
            clearable
            placeholder="请选择状态"
          >
            <el-option value="" label="所有状态" />
            <el-option :value="0" label="待审核" />
            <el-option :value="1" label="待修改" />
            <el-option :value="2" label="已完成" />
          </el-select>
        </el-form-item>
        <el-form-item style="width: 10%">
          <el-select
            v-model="queryParams.levels"
            clearable
            placeholder="请选择评级"
          >
            <el-option value="" label="所有评级" />
            <el-option value="无等级" />
            <el-option value="初始级" />
            <el-option value="规范级" />
            <el-option value="集成级" />
            <el-option value="协同级" />
          </el-select>
        </el-form-item>
        <el-form-item style="width: 10%">
          <el-select
            v-model="queryParams.isChange"
            clearable
            placeholder="请选择分配"
          >
            <el-option value="" label="所有分配" />
            <el-option :value="0" label="未分配" />
            <el-option :value="1" label="已分配" />
          </el-select>
        </el-form-item>
        <el-form-item style="">
          <el-select
            v-model="queryParams.expertId"
            clearable
            placeholder="请选择专家"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :value="user.id"
              :label="user.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item style="width: 25%">
          <el-input
            size="mini"
            v-model="queryParams.monthMoneyBegin"
            clearable
            placeholder="请输入数字化投入最小值(万元)"
            style="width: 38%"
          />
          <el-input
            size="mini"
            v-model="queryParams.monthMoneyEnd"
            clearable
            placeholder="请输入数字化投入最大值(万元)"
            style="width: 38%"
          />
        </el-form-item>
        <el-form-item style="width: 10%">
          <el-input
            size="mini"
            v-model="queryParams.version"
            clearable
            placeholder="请输入评审轮次"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleQuery"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="permissionList.includes('enterprise:list')"
            type="primary"
            size="mini"
            @click="handleInfosDown"
            >导出infos</el-button
          >
          <el-button
            v-if="permissionList.includes('enterprise:list')"
            type="primary"
            size="mini"
            :disabled="selectedRows.length === 0"
            @click="handleAward(selectedRows)"
            >分配权限</el-button
          >
          <el-button
            type="primary"
            size="mini"
            :disabled="selectedRows.length === 0"
            @click="handleBatchExpert(selectedRows)"
            >批量评语</el-button
          >
          <el-button
            type="primary"
            size="mini"
            :disabled="selectedRows.length === 0"
            @click="handleBatchExport(selectedRows)"
            >批量材料</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ backgroundColor: '#eaeaea' }"
        @selection-change="(val) => (selectedRows = val)"
        :default-sort="{
          prop: 'declarationFormSubmitTime',
          order: 'descending',
        }"
        @sort-change="handleSortChange"
        border
      >
        <el-table-column type="selection" width="55" />
        <el-table-column align="center" label="序号" type="index" />
        <el-table-column
          align="center"
          label="企业名称"
          prop="enterpriseName"
        />
        <el-table-column align="center" label="本年度数字化投入">
          <template v-slot="scope">
            <span>{{
              (Object.values(JSON.parse(scope.row.newMonthData || "{}")) ||
                [])[0]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="未来计划数字化投入"
          prop="nowInvestment"
        />
        <el-table-column align="center" label="评级" prop="levels" />
        <el-table-column align="center" label="进度">
          <template v-slot="scope">
            <span>{{ getProgress(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="分配状态"
          v-if="permissionList.includes('enterprise:list')"
        >
          <template v-slot="scope">
            <span>{{ scope.row.childList.length ? "已分配" : "未分配" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="分配人" prop="awardOwner" />
        <el-table-column align="center" label="状态">
          <template v-slot="scope">
            <span>{{
              { 0: "待审核", 1: "待修改", 2: "完结" }[
                scope.row.declarationStatus
              ]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="评审轮次">
          <template v-slot="scope">
            <span>{{ scope.row.version - 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100px"
          align="center"
          label="上传提交时间"
          prop="declarationFormSubmitTime"
          sortable
        >
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template v-slot="scope">
            <el-button
              type="text"
              plain
              size="mini"
              @click="handleStart('question', scope.row)"
              >{{
                scope.row.declarationStatus === 0 ? "评审" : "查看"
              }}</el-button
            >
            <el-dropdown
              size="mini"
              @command="(command) => handleCommand(command, scope.row)"
            >
              <el-button size="mini" type="text" icon="el-icon-d-arrow-right"
                >更多</el-button
              >
              <el-dropdown-menu slot="dropdown">
                <template v-if="permissionList.includes('enterprise:list')">
                  <el-dropdown-item command="award" icon="el-icon-caret-right"
                    >分配权限</el-dropdown-item
                  >
                </template>
                <el-dropdown-item
                  command="ready"
                  icon="el-icon-caret-right"
                  :disabled="
                    !scope.row.ready || scope.row.declarationStatus !== 0
                  "
                  >打回重改</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="scope.row.declarationStatus !== 2"
                  command="finish"
                  icon="el-icon-caret-right"
                  >结束评审</el-dropdown-item
                >
                <el-dropdown-item
                  v-else
                  command="report"
                  icon="el-icon-caret-right"
                  >查看报告</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="scope.row.isReport == 1"
                  command="evidence"
                  icon="el-icon-caret-right"
                  >生成佐证</el-dropdown-item
                >
                <el-dropdown-item command="expert" icon="el-icon-caret-right"
                  >导出评语</el-dropdown-item
                >
                <el-dropdown-item command="export" icon="el-icon-caret-right"
                  >导出材料</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="text-right pt-5 pr-20"
        layout="total,sizes,prev,pager,next,jumper"
        :page-size.sync="queryParams.pageSize"
        :page-sizes="[10, 15, 20, 50, 100]"
        :total="total"
        :current-page.sync="queryParams.pageNum"
        @size-change="loadList"
        @current-change="loadList"
      />
      <el-dialog
        v-if="awardForm.visible"
        width="80%"
        custom-class="full-dialog"
        visible
        :show-close="true"
        :append-to-body="true"
        @close="awardForm.visible = false"
      >
        <award-layer v-bind="awardForm.params" @save="handleAwardSave" />
      </el-dialog>
      <el-dialog
        v-if="exporting.progress"
        visible
        :show-close="true"
        :append-to-body="true"
        @close="Object.assign(exporting, { progress: 0, url: '' })"
      >
        <p>当前完成数: {{ exporting.current }} / {{ exporting.total }}</p>
        <el-progress :percentage="exporting.progress" />
        <el-button
          size="small"
          :disabled="!exporting.url"
          @click="handleBatchDown"
          >下载压缩包</el-button
        >
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import {
  getCommitList,
  getAnswerList,
  getSceneAnswer,
  getEvaluate,
  getScenes,
  getExpert,
  addDistribute,
  getAnswerPivot,
  addDeclaration,
  getFile,
  makeExportExcel,
  // getAvgData,
  makeExpertExcel,
  makeInfosExcel,
} from "@/api/enterprise";
import AnswerLayer from "@/views/proposal/partials/answer-layer";
import SceneLayer from "@/views/proposal/partials/scene-layer";
import AwardLayer from "@/views/manage/proposal/partials/award";
import { mapGetters } from "vuex";
import JSZip from "jszip";
import ReportView from "@/views/manage/proposal/partials/report";
import GeneratEvidence from "@/views/manage/proposal/partials/evidence";

export default {
  components: {
    SceneLayer,
    AnswerLayer,
    AwardLayer,
    ReportView,
    GeneratEvidence,
  },
  data() {
    return {
      loading: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        declarationFormSubmitTimeSort: "1",
      },
      list: [],
      evaluate: [],
      evaluateScenes: [],
      users: [],
      experts: [],
      // avgData: [],
      reviewForm: {
        visible: false,
        type: "question",
        row: {},
        params: {},
      },
      selectedRows: [],
      awardForm: {
        visible: false,
        rows: [],
        params: {},
      },
      exporting: {
        progress: 0,
        url: "",
        current: 0,
        total: 0,
        filename: "",
      },
      reportForm: {
        visible: false,
        row: {},
        params: {},
      },
      evidenceForm: {
        visible: false,
        row: {},
        params: {},
      },
    };
  },
  computed: {
    ...mapGetters(["permissionList"]),
    evaluateObj() {
      return this.evaluate.reduce(
        (obj, item) => {
          obj.cache[item.id] = item;
          item.parent = obj.cache[item.parentId];
          if (item.level === 3) {
            obj.arr.push(item);
          } else if (item.level === 4) {
            obj.cache[item.parentId].question = Object.assign(item, {
              children: [],
            });
            obj.cache[item.parentId].i = item.i;
            delete item.parent;
          } else if (item.level === 5) {
            obj.cache[item.parentId].children.push(item);
            if (item.name === "无") {
              item.isZore = true;
            }
            delete item.parent;
          }
          return obj;
        },
        { arr: [], cache: {} }
      );
    },
    questions() {
      return this.evaluateObj.arr;
    },
    questionAnswerObj() {
      return this.evaluateObj.cache;
    },
    evaluateSceneObj() {
      return this.evaluateScenes.reduce(
        (obj, item) => {
          obj.cache[item.id] = item;
          item.parent = obj.cache[item.parentId];
          if (item.level === 2) {
            obj.arr.push(Object.assign(item, { i: obj.arr.length + 1 }));
            item.children = [];
          } else if (item.level === 3) {
            obj.cache[item.parentId].children.push(item);
            delete item.parent;
          }
          return obj;
        },
        { arr: [], cache: {} }
      );
    },
    scenes() {
      return this.evaluateSceneObj.arr;
    },
    sceneAnswerObj() {
      return this.evaluateSceneObj.cache;
    },
  },
  mounted() {
    this.loadEvaluate().then(() => {
      this.loadList();
    });
  },
  methods: {
    handleSortChange(column) {
      console.log("column", column);
      this.queryParams.declarationFormSubmitTimeSort =
        column.order === "ascending"
          ? "0"
          : column.order === "descending"
          ? "1"
          : "";
      this.loadList();
    },
    loadEvaluate() {
      return Promise.all([
        getEvaluate({ pId: 0, treeLink: "0;", version: 1 }).then((res) => {
          this.evaluate = res.data;
        }),
        getScenes({ pId: 0, treeLink: "0;", version: 1 }).then((res) => {
          this.evaluateScenes = res.data;
        }),
        getExpert().then((res) => {
          this.experts = res.data;
          this.users = res.data.filter((v) => !v.remark);
        }),
        // getAvgData().then(res => {
        //   const data = res.data || {}
        //   this.avgData = {
        //     dz: data.dz || '',
        //     dzIsMain: data.dzIsMain || '',
        //     dzLevel: (data.dzLevel || '').split(','),
        //     dzScore: (data.dzScore || '').split(','),
        //     gd: data.gd || '',
        //     gdIsMain: data.gdIsMain || '',
        //     gdLevel: (data.gdLevel || '').split(','),
        //     gdScore: (data.gdScore || '').split(','),
        //     qc: data.qc || '',
        //     qcIsMain: data.qcIsMain || '',
        //     qcLevel: (data.qcLevel || '').split(','),
        //     qcScore: (data.qcScore || '').split(','),
        //     qt: data.qt || '',
        //     qtIsMain: data.qtIsMain || '',
        //     qtLevel: (data.qtLevel || '').split(','),
        //     qtScore: (data.qtScore || '').split(','),
        //     zc: data.zc || '',
        //     zcIsMain: data.zcIsMain || '',
        //     zcLevel: (data.zcLevel || '').split(','),
        //     zcScore: (data.zcScore || '').split(','),
        //     zn: data.zn || '',
        //     znIsMain: data.znIsMain || '',
        //     znLevel: (data.znLevel || '').split(','),
        //     znScore: (data.znScore || '').split(',')
        //   }
        // })
      ]);
    },
    loadList() {
      this.loading = true;
      getCommitList(
        Object.assign(
          {},
          this.queryParams,
          this.queryParams.version
            ? { version: this.queryParams.version * 1 + 1 }
            : {}
        )
      )
        .then((res) => {
          return Promise.all(
            res.data.list.reduce(
              (a, row) =>
                a.concat(
                  makeRow(
                    Object.assign(row, {
                      declarationStatus: row.declarationStatus * 1,
                    }),
                    this.users,
                    this.permissionList
                  )
                ),
              []
            )
          ).then(() => res.data);
        })
        .then((data) => {
          this.loading = false;
          this.total = data.total;
          this.list = data.list.map((v) =>
            Object.assign(
              v,
              buildQuestionTree(this.evaluate, v.quesAnswers),
              buildSceneTree(this.evaluateScenes, v.sceneAnswers)
            )
          );
        })
        .catch((e) => {
          console.log("catch e", e);
          this.loading = false;
        });
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.loadList();
    },
    handleStart(type, row) {
      const role = this.permissionList.includes("enterprise:list")
        ? "admin"
        : "expert";
      const isView = row.declarationStatus !== 0;
      const mode = row.declarationStatus === 0 ? "edit" : "view";
      Object.assign(this.reviewForm, {
        visible: true,
        type,
        row,
        params:
          type === "question"
            ? {
                info: row,
                questions: row.questions,
                answers: row.quesAnswers,
                all: row.quesAllAnswers,
                tree: row.questionTree,
                isView,
                role,
                mode,
              }
            : {
                info: row,
                questions: row.scenes,
                answers: row.sceneAnswers,
                all: row.sceneAllAnswers,
                tree: row.sceneTree,
                isView,
                role,
                mode,
              },
      });
    },
    handleCommand(cmd, row) {
      switch (cmd) {
        case "award":
          this.handleAward([row]);
          break;
        case "ready":
          this.$confirm(
            `是否打回${row.enterpriseName}的答卷，将状态改为待修改?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              showClose: true,
              type: "warning",
            }
          ).then(() => {
            addDeclaration({ userId: row.userId, declarationStatus: 1 }).then(
              (res) => {
                if (res.code === 200) {
                  this.loadList();
                }
              }
            );
          });
          break;
        case "finish":
          this.$confirm(
            `是否结束${row.enterpriseName}的答卷，将状态改为已完成?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              showClose: true,
              type: "warning",
            }
          ).then(() => {
            addDeclaration({ userId: row.userId, declarationStatus: 2 }).then(
              (res) => {
                if (res.code === 200) {
                  row.declarationStatus = 2;
                  Object.assign(
                    row,
                    calcAnswers(
                      row.quesAllAnswers,
                      row.sceneAllAnswers,
                      row.pivots,
                      row,
                      this.permissionList
                    )
                  );
                }
              }
            );
          });
          break;
        case "expert":
          this.handleBatchExpert(
            [row],
            `${row.enterpriseName}-${row.awardOwner}-评语.zip`
          );
          break;
        case "export":
          this.handleBatchExport([row], `${row.enterpriseName}.zip`);
          break;
        case "report":
          Object.assign(this.reportForm, { visible: true, row, params: row });
          break;
        case "evidence":
          Object.assign(this.evidenceForm, { visible: true, row, params: row });
          break;
      }
    },
    handleAward(arr) {
      Object.assign(this.awardForm, {
        visible: true,
        rows: arr,
        params: {
          evaluate: this.evaluate,
          evaluateScenes: this.evaluateScenes,
          users: this.users,
        },
      });
    },
    updateProgress() {
      const form = this.reviewForm;
      const type = form.type;
      const row = form.params.info;
      makeRow(row, this.users, this.permissionList).then(() => {
        Object.assign(
          row,
          buildQuestionTree(this.evaluate, row.quesAnswers),
          buildSceneTree(this.evaluateScenes, row.sceneAnswers)
        );
        Object.assign(
          form.params,
          type === "question"
            ? {
                info: row,
                questions: row.questions,
                answers: row.quesAnswers,
                all: row.quesAllAnswers,
                tree: row.questionTree,
              }
            : {
                info: row,
                questions: row.scenes,
                answers: row.sceneAnswers,
                all: row.sceneAllAnswers,
                tree: row.sceneTree,
              }
        );
      });
    },
    async handleInfosDown() {
      const excel = await makeInfosExcel();
      if (excel.code !== 200) {
        throw new Error("excel fail");
      }
      await getFile(excel.message).then((res) => {
        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `infos-${new Date().getFullYear()}-${
          new Date().getMonth() + 1
        }-${new Date().getDate()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      });
    },
    async handleBatchExpert(arr, filename) {
      Object.assign(this.exporting, {
        progress: 1,
        url: "",
        current: 0,
        total: arr.length,
        filename,
      });
      try {
        const zip = new JSZip();

        for (const i in arr) {
          const one = arr[i];
          const excel = await makeExpertExcel(one.userId);
          if (excel.code !== 200) {
            throw new Error("excel fail");
          }
          await getFile(excel.message).then((buffer) => {
            saveFile(
              `${one.enterpriseName}-${one.awardOwner}.xlsx`,
              buffer,
              zip,
              { type: "infos" }
            );
          });
          this.exporting.current = i * 1 + 1;
          this.exporting.progress =
            (
              (this.exporting.current / this.exporting.total - 0.01) *
              100
            ).toFixed(2) * 1;
        }
        this.exporting.progess = 99.99;
        const blob = await zip.generateAsync({ type: "blob" });
        const url = window.URL.createObjectURL(blob);
        Object.assign(this.exporting, { progress: 100, url });
      } catch (e) {
        console.log("expert catch", e);
        this.$confirm("导出出错，请销后再试", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          showCancelButton: false,
          type: "warning",
        }).then(() => {
          this.exporting.progress = 0;
        });
      }
    },
    async handleBatchExport(arr, filename) {
      Object.assign(this.exporting, {
        progress: 1,
        url: "",
        current: 0,
        total: arr.length,
        filename,
      });
      try {
        const zip = new JSZip();

        const excel = await makeExportExcel(arr.map((v) => v.userId));
        if (excel.code !== 200) {
          throw new Error("excel fail");
        }
        await getFile(excel.message).then((buffer) => {
          saveFile("infos.xlsx", buffer, zip, { type: "infos" });
        });

        for (const i in arr) {
          const one = arr[i];
          await appendFile(one, zip, this.questions, this.scenes);
          this.exporting.current = i * 1 + 1;
          this.exporting.progress =
            (
              (this.exporting.current / this.exporting.total - 0.01) *
              100
            ).toFixed(2) * 1;
        }
        this.exporting.progress = 99.99;

        const blob = await zip.generateAsync({ type: "blob" });
        const url = window.URL.createObjectURL(blob);
        Object.assign(this.exporting, { progress: 100, url });
      } catch (e) {
        console.log("catch", e);
        this.$confirm("导出出错，请销后再试", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          showCancelButton: false,
          type: "warning",
        }).then(() => {
          this.exporting.progress = 0;
        });
      }
    },
    handleBatchDown() {
      const a = document.createElement("a");
      a.href = this.exporting.url;
      a.download =
        this.exporting.filename ||
        `${new Date().getFullYear()}-${
          new Date().getMonth() + 1
        }-${new Date().getDate()}导出.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(this.exporting.url);
      this.exporting.progress = 0;
    },
    handleAwardSave(data) {
      addDistribute(
        this.awardForm.rows.reduce(
          (a, enterprise) =>
            a.concat(
              data[0].reduce(
                (a, q) =>
                  a.concat(
                    data[1].reduce(
                      (a, u) =>
                        a.concat({
                          enterpriseId: enterprise.id,
                          userId: u,
                          quesId: q.split("-")[1],
                          type: q.split("-")[0],
                        }),
                      []
                    )
                  ),
                []
              )
            ),
          []
        )
      ).then((res) => {
        this.$message.success("提交成功！");
        Object.assign(this.awardForm, { visible: false });
        this.loadList();
      });
    },
    handleAnswerPivot({ info }) {
      getAnswerPivot({ userId: info.userId }).then((res) => {
        Object.assign(
          info,
          calcAnswers(
            info.quesAllAnswers,
            info.sceneAllAnswers,
            res.data || [],
            info,
            this.permissionList
          )
        );
        Object.assign(this.reviewForm.params, {
          answers: info.quesAnswers,
          all: info.quesAllAnswers,
        });
      });
    },
    handleScenePivot({ info }) {
      getAnswerPivot({ userId: info.userId }).then((res) => {
        Object.assign(
          info,
          calcAnswers(
            info.quesAllAnswers,
            info.sceneAllAnswers,
            res.data || [],
            info,
            this.permissionList
          )
        );
        Object.assign(this.reviewForm.params, {
          answers: info.sceneAnswers,
          all: info.sceneAllAnswers,
        });
      });
    },
    getProgress(row) {
      if (row.declarationStatus * 1 === 0) {
        return `审核进度 问卷: ${row.quesProgress}/${row.quesLength} 场景:${row.sceneProgress}/${row.sceneLength}`;
      } else if (row.declarationStatus * 1 === 1) {
        return `修改进度 问卷: ${row.quesProgress}/${row.quesLength} 场景:${row.sceneProgress}/${row.sceneLength}`;
      } else {
        return "完结";
      }
    },
  },
};

function calcAnswers(answers, scenes, pivot, info, permissions) {
  const quesAll = answers
    .filter((v) => v.version * 1 <= info.version)
    .map((v) =>
      Object.assign(v, {
        pivot: pivot.find(
          (p) =>
            p.userId * 1 === v.userId * 1 &&
            p.quesId * 1 === v.quesId * 1 &&
            p.version * 1 === v.version * 1 &&
            p.type === 0
        ),
      })
    );
  const sceneAll = scenes
    .filter((v) => v.version * 1 <= info.version)
    .map((v) =>
      Object.assign(v, {
        pivot: pivot.find(
          (p) =>
            p.userId * 1 === v.userId * 1 &&
            p.quesId * 1 === v.quesId * 1 &&
            p.version * 1 === v.version * 1 &&
            p.type === 1
        ),
      })
    );
  const quesCurrent = answers.filter((v) => v.version * 1 === info.version);
  const sceneCurrent = scenes.filter((v) => v.version * 1 === info.version);
  const progress = {
    ques: 0,
    scene: 0,
  };
  if (info.declarationStatus === 0) {
    progress.ques = quesCurrent.filter((v) => v.pivot).length;
    progress.scene = sceneCurrent.filter((v) => v.pivot).length;
  } else if (info.declarationStatus === 1) {
    progress.ques = quesCurrent.filter(
      (v) =>
        v.status === 1 ||
        quesAll.find(
          (_) =>
            v.quesId * 1 === _.quesId * 1 && _.version * 1 === info.version - 1
        ).pivot.status === 1
    ).length;
    progress.scene = sceneCurrent.filter(
      (v) =>
        v.status === 1 ||
        sceneAll.find(
          (_) =>
            v.quesId * 1 === _.quesId * 1 && _.version * 1 === info.version - 1
        ).pivot.status === 1
    ).length;
  }
  if (permissions.includes("enterprise:list")) {
    return {
      quesAnswers: quesCurrent,
      sceneAnswers: sceneCurrent,
      quesAllAnswers: quesAll,
      sceneAllAnswers: sceneAll,
      quesProgress: progress.ques,
      sceneProgress: progress.scene,
      quesLength: quesCurrent.length,
      sceneLength: sceneCurrent.length,
      ready:
        progress.ques === quesCurrent.length &&
        progress.scene === sceneCurrent.length,
      pivots: pivot,
    };
  } else {
    const quesKeys = info.childList
      .filter((v) => v.type === "q")
      .map((v) => v.quesId);
    const sceneKeys = info.childList
      .filter((v) => v.type === "s")
      .map((v) => v.quesId);
    const quesAnswers = quesCurrent.filter((v) =>
      quesKeys.includes(v.quesId * 1)
    );
    const sceneAnswers = sceneCurrent.filter((v) =>
      sceneKeys.includes(v.quesId * 1)
    );
    return {
      quesAnswers,
      sceneAnswers,
      quesAllAnswers: quesAll.filter((v) => quesKeys.includes(v.quesId * 1)),
      sceneAllAnswers: sceneAll.filter((v) => sceneKeys.includes(v.quesId * 1)),
      quesProgress: progress.ques,
      sceneProgress: progress.scene,
      quesLength: quesAnswers.length,
      sceneLength: sceneAnswers.length,
      ready:
        progress.ques === quesCurrent.length &&
        progress.scene === sceneCurrent.length,
      pivots: pivot,
    };
  }
}

function makeRow(row, users, permissionList) {
  return Promise.all([
    getAnswerList({ userId: row.userId }),
    getSceneAnswer({ userId: row.userId }),
    getAnswerPivot({ userId: row.userId }),
  ]).then((arr) => {
    return Object.assign(
      row,
      {
        declarationStatus: row.declarationStatus * 1,
        awardOwner:
          Array.from(
            new Set(
              row.childList.map(
                (v) => users.find((u) => u.id === v.userId)?.name || ""
              )
            )
          ).join(",") || "无",
      },
      calcAnswers(
        arr[0].data || [],
        arr[1].data || [],
        arr[2].data || [],
        row,
        permissionList
      )
    );
  });
}

function buildQuestionTree(arr, answers) {
  const questions = arr
    .reduce(
      (obj, item) => {
        const cache = (obj.cache[item.id] = Object.assign({}, item));
        obj.cache[cache.id].parent = obj.cache[cache.parentId];
        if (cache.level === 3) {
          obj.arr.push(
            Object.assign(obj.cache[cache.id], { i: obj.arr.length + 1 })
          );
        } else if (cache.level === 4) {
          obj.cache[cache.parentId].question = Object.assign(
            obj.cache[cache.id],
            { children: [] }
          );
          obj.cache[cache.parentId].ii = obj.cache[cache.id].i;
          delete obj.cache[cache.id].parent;
        } else if (cache.level === 5) {
          obj.cache[cache.parentId].children.push(obj.cache[cache.id]);
          delete obj.cache[cache.id].parent;
        }
        return obj;
      },
      { arr: [], cache: {} }
    )
    .arr.filter((v) => answers.find((a) => a.quesId * 1 === v.question.id));

  const tree = questions.reduce(
    (o, v) => {
      const parent = v.parent;
      const grandpa = parent.parent;
      if (!o.cache[grandpa.id]) {
        o.cache[grandpa.id] = {
          id: grandpa.id,
          name: grandpa.name,
          label: grandpa.name,
          level: grandpa.level,
          children: [],
        };
        o.tree.push(o.cache[grandpa.id]);
      }
      if (!o.cache[parent.id]) {
        o.cache[parent.id] = {
          id: parent.id,
          name: parent.name,
          label: parent.name,
          level: parent.level,
          children: [],
        };
        o.cache[grandpa.id].children.push(o.cache[parent.id]);
      }
      o.cache[parent.id].children.push({
        id: v.id,
        name: v.name,
        label: v.name,
        level: v.level,
      });
      return o;
    },
    { tree: [], cache: {} }
  ).tree;
  return {
    questions,
    questionTree: tree,
  };
}
function buildSceneTree(arr, answers) {
  const scenes = arr
    .reduce(
      (obj, item) => {
        const cache = (obj.cache[item.id] = Object.assign({}, item));
        cache.parent = obj.cache[cache.parentId];
        if (cache.level === 2) {
          obj.arr.push(Object.assign(cache, { i: obj.arr.length + 1 }));
          cache.children = [];
        } else if (cache.level === 3) {
          obj.cache[cache.parentId].children.push(cache);
          delete cache.parent;
        }
        return obj;
      },
      { arr: [], cache: {} }
    )
    .arr.filter((v) => answers.find((a) => a.quesId * 1 === v.id));

  const tree = scenes.reduce(
    (o, v) => {
      const parent = v.parent;
      if (!o.cache[parent.id]) {
        o.cache[parent.id] = {
          id: parent.id,
          name: parent.name,
          label: parent.name,
          level: parent.level,
          children: [],
        };
        o.tree.push(o.cache[parent.id]);
      }
      o.cache[parent.id].children.push({
        id: v.id,
        name: v.name,
        label: v.name,
        level: v.level,
      });

      return o;
    },
    { tree: [], cache: {} }
  ).tree;
  return {
    scenes,
    sceneTree: tree,
  };
}

async function appendFile(info, zip, evaluates, scenes) {
  const root = zip.folder(`${info.userId}-${info.enterpriseName}`);
  const evaluate = root.folder("1评测");
  const scene = root.folder("2场景");

  const answers = info.quesAnswers.map((v) =>
    Object.assign({}, v, {
      quesId: v.quesId * 1,
      ans: JSON.parse(v.ans),
      fileIds: JSON.parse(v.fileIds),
      otherAns: JSON.parse(v.otherAns),
    })
  );
  const sceneAnswers = info.sceneAnswers.map((v) =>
    Object.assign({}, v, {
      quesId: v.quesId * 1,
      ans: JSON.parse(v.ans),
      fileIds: JSON.parse(v.fileIds),
    })
  );

  for (const e of evaluates) {
    const folder = evaluate.folder(e.name);
    const answer = answers.find((v) => v.quesId * 1 === e.question.id * 1);
    if (!answer) continue;

    if ([5].includes(e.question.i)) {
      await Promise.all(
        Object.values(answer.otherAns)
          .reduce(
            (a, item, i) =>
              a.concat(
                item.fileIds.map((v) =>
                  Object.assign(v, { name: `${i}-${v.name}` })
                )
              ),
            []
          )
          .map((file) =>
            getFile(file.id).then((buffer) => {
              saveFile(file.name, buffer, folder, {
                type: "ques",
                quesId: answer.quesId,
                i: e.question.i,
                fileId: file.id,
              });
            })
          )
      );
    } else {
      await Promise.all(
        answer.fileIds.map((file) =>
          file
            ? getFile(file.id).then((buffer) => {
                saveFile(file.name, buffer, folder, {
                  type: "ques",
                  quesId: answer.quesId,
                  i: e.question.i,
                  fileId: file.id,
                });
              })
            : new Promise((resolve) => {
                console.log("file empty", answer.id);
                resolve();
              })
        )
      );
    }
  }

  for (const s of sceneAnswers) {
    const one = scenes.find((v) => v.id === s.quesId);
    if (!one || s.ans.reduce((n, a) => n + a.length, 0) === 0) continue;
    const folder = scene.folder(one.name);
    for (const i in s.ans) {
      const dir = folder.folder(["一级", "二级", "三级", "四级"][i]);
      if (s.fileIds[i].some((v) => !v)) {
        console.log("empty fileIds", s.quesId, s.ans);
      }
      await Promise.all(
        s.fileIds[i]
          .filter((v) => v)
          .map((file) =>
            getFile(file.id).then((buffer) => {
              saveFile(file.name, buffer, dir, {
                type: "scene",
                quesId: s.quesId,
                index: i,
                fileId: file.id,
              });
            })
          )
      );
    }
  }
}

function saveFile(filename, data, zip, info) {
  const blob = data.data;
  if (blob.size === 0) {
    console.log(`${filename} get empty buffer`, info);
    return;
  }
  zip.file(filename, blob);
}
</script>
